import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'it',
  months: [
    'gennaio',
    'febbraio',
    'marzo',
    'aprile',
    'maggio',
    'giugno',
    'luglio',
    'agosto',
    'settembre',
    'ottobre',
    'novembre',
    'dicembre',
  ],
  monthsShort: ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'],
  weekdays: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
  weekdaysMin: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
  weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY HH:mm',
    'lll-Y': 'D MMM HH:mm',
    llll: 'ddd D MMM YYYY HH:mm',
    'llll-Y': 'ddd D MMM HH:mm',
    'll-Y+w': 'ddd D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY HH:mm ([GMT]Z)',
  },
  past: {
    y: { one: '%s anno fa', other: '%s anni fa' },
    M: { one: '%s mese fa', other: '%s mesi fa' },
    w: { one: '%s sett. fa', other: '%s sett. fa' },
    d: { one: '%s g fa', other: '%s gg fa' },
    h: { one: '%s h fa', other: '%s h fa' },
    m: { one: '%s min fa', other: '%s min fa' },
    s: { one: '%s sec. fa', other: '%s sec. fa' },
  },
  future: {
    y: { one: 'tra %s anno', other: 'tra %s anni' },
    M: { one: 'tra %s mese', other: 'tra %s mesi' },
    w: { one: 'tra %s sett.', other: 'tra %s sett.' },
    d: { one: 'tra %s g', other: 'tra %s gg' },
    h: { one: 'tra %s h', other: 'tra %s h' },
    m: { one: 'tra %s min', other: 'tra %s min' },
    s: { one: 'tra %s sec.', other: 'tra %s sec.' },
  },
  abbr: {
    y: { one: '%sanno', other: '%sanni' },
    M: { one: '%sm', other: '%sm' },
    w: { one: '%sset', other: '%sset' },
    d: { one: '%sg', other: '%sg' },
    h: { one: '%so', other: '%so' },
    m: { one: '%smin', other: '%smin' },
    s: { one: '%ss', other: '%ss' },
  },
  justNow: 'Adesso',
  yesterday: 'Ieri',
  today: 'Oggi',
  tomorrow: 'Domani',
  weekStart: 1,
};
const localeName: LocaleName = 'it';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (): string => '',
};
